import { config } from '../client/'

export default async () => {
  const url = `https://us-central1-${config.project}.cloudfunctions.net/getNow`
  return await fetch(url).then(data => data.text())
}
